export default {
  className: 'article',
  fields: [
    {
      // 封面图
      name: 'cover',
      validators: [
        // 可以使用多个验证，依次执行，碰到第一个错误时停止验证
        (value) => value ? null : '封面图不可为空'
      ]
    },
    {
      // 标题
      name: 'headline',
      validators: [
        // 可以使用多个验证，依次执行，碰到第一个错误时停止验证
        (value) => value ? null : '标题不可为空'
      ]
    },
    {
      // 内容
      name: 'content',
      validators: [
        // 可以使用多个验证，依次执行，碰到第一个错误时停止验证
        (value) => value ? null : '内容不可为空'
      ]
    },
    {
      // 简介
      name: 'synopsis',
      validators: [
        // 可以使用多个验证，依次执行，碰到第一个错误时停止验证
        (value) => value ? null : '简介不可为空'
      ]
    },
    {
      // 是否展示
      name: 'show'
    }
  ],
  action: {
    export: false
  },
  search: [
    'headline',
    'show'
  ]
}
